import React from "react";
import { Toaster } from "react-hot-toast";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import moment from "moment";
import "moment/locale/ko";
import Main from "./pages/MainPage";
import ParentPage from "./pages/parent/ParentPage";
import StudentPage from "./pages/student/StudentPage";
import LectureViewPage from "./pages/lecture/LectureViewPage";
import SurveyForPage from "./pages/survey/SurveyForPage";
import CertificateViewPage from "./pages/certificate/CertificateViewPage";
import SignUpPage from "./pages/user/SignUpPage";
import SignOutPage from "./pages/user/SignOutPage";
import FindOutPage from "./pages/user/FindOutPage";

const App = () => {
  moment().locale("ko");
  return (
    <BrowserRouter>
      <Routes>
        <Route path="*" element={<Main />} />
        <Route path="certificate/view" element={<CertificateViewPage />} />
        <Route path="lecture/view/:lecture_id" element={<LectureViewPage />} />
        <Route path="survey/response/:id" element={<SurveyForPage />} />
        <Route path="parent/*" element={<ParentPage />} />
        <Route path="student/*" element={<StudentPage />} />
        <Route path="signup" element={<SignUpPage />} />
        <Route path="signout" element={<SignOutPage />} />
        <Route path="findout" element={<FindOutPage />} />
      </Routes>
      <Toaster position="bottom-right" reverseOrder={false} />
    </BrowserRouter>
  );
};

export default App;
